export default __webpack_public_path__ + "static/media/pdf-image.380a93d2.png";